import Vue from 'vue';
// import FileModel from '@/models/Image.model';

class FileService {
  static upload(files) {
    return new Promise((resolve, reject) => {
      const formData = new FormData();

      for (let i = 0; i < files.length; i += 1) {
        formData.append('files', files[i]);
      }

      Vue.http
        .post(`${this.resource}/`, formData)
        .then(response => resolve(response.body))
        .catch(err => reject(new Error(err)));
    });
  }

  static uploadImages(files) {
    return new Promise((resolve, reject) => {
      const formData = new FormData();

      for (let i = 0; i < files.length; i += 1) {
        formData.append('images', files[i]);
      }

      Vue.http
        .post(`${this.resource}/images/`, formData)
        .then(response => resolve(response.body))
        .catch(err => reject(new Error(err)));
    });
  }

  static delete(id) {
    return new Promise((resolve, reject) => {
      Vue.http
        .delete(`${this.resource}/${id}/`)
        .then(response => resolve(response.body))
        .catch(err => reject(new Error(err)));
    });
  }
}

Object.assign(FileService, {
  resource: 'uploads',
});

export default FileService;
